import { InfoPageDarkText } from './InfoPageDarkText.style';

export default InfoPageDarkText;
